import { getOfflineSubscriptionUIDs } from '@api/selectors/subscription';
import useFetch from '@hooks/useFetch';
import { readCookie } from '@utils/cookies';
import useMyInfo from '../auth/useMyInfo';

const useFormDetails = (formType) => {
  const accessToken = readCookie('accessToken');
  const hasOfflineSubscription =
    useMyInfo(getOfflineSubscriptionUIDs).length > 0;

  const shouldFetch = !!accessToken && hasOfflineSubscription;
  const key = `v1/offline_centres/user-forms/?form-type=${formType}`;
  const { data: formDetails, ...rest } = useFetch(shouldFetch ? key : null);
  return { formDetails, ...rest };
};

export default useFormDetails;
